import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DedicatedResolutionSpecialistCard from "../RightSideCard/DedicatedResolutionSpecialistCard";
import ChildCreditActivityMonitoring from "./ChildCreditActivityMonitoring";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import Ccamfaq from "./Ccamfaq";
// import HowDoIFreezeMyMinor from "./HowDoIFreezeMyMinor";

const ChildCreditActivity = (props: any) => {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [activityDetected, setActivityDetected] = useState(false);
    const updateActivityDetected = () => {
        setActivityDetected(true);
    };
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            {/*<!-- Page Title -->*/}
            <div className="row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        Credit Activity
                    </h1>
                </div>
            </div>

            {/*<!-- Page Content -->*/}
            <div className="row  margin-bottom-s" id="content">
                <div className="col-xs col-no-gutter">
                    <div className="row">
                        <div className={"col-xs-12 col-sm-7 col-md-8 col-lg-8"}>
                            <ChildCreditActivityMonitoring updateActivityDetected={updateActivityDetected} />
                            {/*<HowDoIFreezeMyMinor />*/}
                            <Ccamfaq activityDetected={activityDetected} />
                        </div>

                        {/* Right side cards*/}
                        <div className={"col-xs-12 col-sm-5 col-md-4 col-lg-4"}>
                            <DedicatedResolutionSpecialistCard />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ChildCreditActivity;
